import { IconCloseSquare } from 'components/Icons/IconCloseSquare';
import { cx } from '@linaria/core';
import { ReactNode } from 'react';
import { IconBack } from 'components/Icons';
import { closeButton, goBackButton, dialogHeading } from './dialogComponents.styles';

type DialogButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & { size?: number };

export const dialogComponents = {
  CloseButton: ({ className, size = 18, ...props }: DialogButtonProps) => (
    <button className={cx(closeButton, className)} type="button" data-testid="dialog-closebtn" {...props}>
      <IconCloseSquare size={size} color="#282636" />
    </button>
  ),
  GoBack: ({ className, size = 14, ...props }: DialogButtonProps) => (
    <button className={cx(goBackButton, className)} type="button" data-testid="dialog-gobackbtn" {...props}>
      <IconBack size={size} color="#282636" />
    </button>
  ),
  Heading: ({ children, className }: { children: ReactNode; className?: string }) => <h3 className={cx(dialogHeading, className)}>{children}</h3>,
};
